import { Vue } from 'vue-property-decorator';
import { WidgetData } from '@/components/Dashboard/Widgets/types/Widget';

export interface WidgetContent<T> {
    config: T | null | undefined;
}

export interface WidgetConfig<T> {
    config: T | null | undefined;
}

export abstract class AbstractWidgetContent<T> extends Vue implements WidgetContent<T> {
    abstract config: T | null | undefined;
    abstract refresh(widgetData: WidgetData): void;

    // ヘッダーの更新ボタンが押されたとき、eventHubでrefresh()が呼ばれる
}

export abstract class AbstractWidgetConfig<T> extends Vue implements WidgetConfig<T> {
    abstract config: T | null | undefined;
    abstract validate(): void;
}